/**
 * The id of the JSON block that carries the page's config into the frame. Data, not an inline
 * script: a srcdoc frame inherits the CSP of the app that holds it, and the deployed app's allows no
 * inline script, so a script that set the config would never run.
 */
export const WIDGET_CONFIG_ID = 'mf-widget-config';
/** The block for the frame's head, as JSON that cannot end the script element it sits in. */
export function hostConfigBlock(config) {
    const json = JSON.stringify(config)
        .replace(/</g, '\\u003c')
        .replace(/>/g, '\\u003e')
        .replace(/&/g, '\\u0026');
    return `<script type="application/json" id="${WIDGET_CONFIG_ID}">${json}</script>`;
}
/** Where the runtime origin serves `LEGACY_CONFIG_SCRIPT`, beside the runtime folders. */
export const LEGACY_CONFIG_FILE = 'legacy-config.js';
/**
 * Sets the global a runtime from before the block reads. Runtimes are frozen by hash, so widgets
 * stored on one keep loading it; the page runs this ahead of `host.js` from the runtime's own
 * origin, which both the frame's CSP and the app's allow.
 */
export const LEGACY_CONFIG_SCRIPT = `(function(){var b=document.head.querySelector('script#${WIDGET_CONFIG_ID}');if(b&&b.textContent)window.__mfWidget=JSON.parse(b.textContent);})();`;
/** The config the page wrote in the frame's head, ahead of any element the widget could add. */
export function readHostConfig(document) {
    const block = document.head.querySelector(`script#${WIDGET_CONFIG_ID}`);
    if (block?.textContent)
        return JSON.parse(block.textContent);
    // A page built before the block set a global instead, which still runs where no CSP stops it.
    const legacy = document.defaultView?.__mfWidget;
    if (legacy)
        return legacy;
    throw new Error(`The widget page carried no config: no #${WIDGET_CONFIG_ID} block in its head`);
}
